import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "ds-chip__icon"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "ds-chip__inner" }
const _hoisted_4 = {
  key: 3,
  class: "ds-chip__icon"
}
const _hoisted_5 = ["src"]

import { computed } from "vue";
import { SvgIcons } from "../icon/types";
import DsIcon from "../icon/ds-icon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ds-chip',
  props: {
    tag: { default: "span" },
    type: { default: "assist" },
    theme: { default: "light" },
    href: {},
    isActive: { type: Boolean },
    isDisabled: { type: Boolean },
    isPassive: { type: Boolean },
    iconLeft: {},
    iconRight: {},
    imageLeftUrl: {},
    imageRightUrl: {},
    isExternal: { type: Boolean },
    isInStorybook: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const tagName = computed(() => {
    if (props.tag === "auto") {
        return props.href ? "a" : "button";
    }
    return props.tag;
});

const isDisabled = computed(() => props.isDisabled || props.isPassive);

const resolvedClass = computed(() => [
    `ds-chip`,
    `ds-chip--${props.type}`,
    props.isActive ? "ds-chip--active" : "",
    isDisabled.value ? "ds-chip--disabled" : "",
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(tagName.value), {
    href: tagName.value === 'a' ? _ctx.href : undefined,
    class: _normalizeClass(resolvedClass.value),
    disabled: isDisabled.value && tagName.value === 'button' ? '' : undefined,
    target: _ctx.isExternal && tagName.value === 'a' ? '_blank' : undefined,
    rel: _ctx.isExternal && tagName.value === 'a' ? 'noopener noreferrer' : undefined
  }, {
    default: _withCtx(() => [
      (_ctx.iconLeft)
        ? (_openBlock(), _createBlock(DsIcon, {
            key: 0,
            name: _ctx.iconLeft,
            class: "ds-chip__icon",
            width: 16,
            height: 16,
            "is-in-storybook": _ctx.isInStorybook
          }, null, 8, ["name", "is-in-storybook"]))
        : (_ctx.imageLeftUrl)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
              _createElementVNode("img", {
                src: _ctx.imageLeftUrl,
                class: "ds-chip__image",
                width: "28",
                height: "28",
                alt: ""
              }, null, 8, _hoisted_2)
            ]))
          : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      (_ctx.iconRight)
        ? (_openBlock(), _createBlock(DsIcon, {
            key: 2,
            name: _ctx.iconRight,
            class: "ds-chip__icon",
            width: 16,
            height: 16,
            "is-in-storybook": _ctx.isInStorybook
          }, null, 8, ["name", "is-in-storybook"]))
        : (_ctx.imageRightUrl)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              _createElementVNode("img", {
                src: _ctx.imageRightUrl,
                class: "ds-chip__image",
                width: "28",
                height: "28",
                alt: ""
              }, null, 8, _hoisted_5)
            ]))
          : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["href", "class", "disabled", "target", "rel"]))
}
}

})